import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { webappRoute } from "./layout"

export const palmistryRoute = createRoute({
  getParentRoute: () => webappRoute,
  path: "/palmistry",
  component: lazyRouteComponent(() => import("./lazy-pages"), "PalmistryPage"),
})
